// export const LiveUrl = "https://api-lkctc.simbaquartz.com";

export const LiveUrl = "https://api.kclimt.com";

// export const LiveUrl = "http://localhost:5000";
